import React from 'react';
import { renderButton } from './shared/renderers';

export default function ButtonBlock({ props = {}, theme }) {
  return renderButton(props, theme);
}
